import React from 'react'
import HomeBannerImage from 'url:../assets/images/homebanner.png'
import { Banner } from './Banner'
import { ServiceTiles } from './ServiceTiles'

export const Home = () => {
  return (
    <main>
      <Banner imagePath={HomeBannerImage} imageAlt={'Home Banner'} />
      <ServiceTiles />
    </main>
  )
}
